import { createContext, useContext } from 'react';
const SettingsChipToneContext = createContext('warning');
export const SettingsChipToneProvider = SettingsChipToneContext.Provider;
export const useSettingsChipTone = ()=>useContext(SettingsChipToneContext);
